import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';

import { AgGridModule } from 'ag-grid-angular';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { Route, RouterModule } from '@angular/router';
import {
  NgbCollapseModule,
  NgbDropdownModule,
  NgbModule,
} from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { RepoBusinessListComponent } from './repo-business-list/repo-business-list.component';
import { AuthGuard } from '../auth.guard';
import { PositionsPopupComponent } from './positions/positions-popup.component';
import { RepoContactsPopupComponent } from './repo-contacts/repo-contacts-popup.component';
import { RepoBusinessPopupComponent } from './repo-business-popup/repo-business-popup.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { MatTabsModule } from '@angular/material/tabs';
import { RepoBusinessComponent } from './repo-business/repo-business.component';
import { PositionEditComponent } from './position-edit/position-edit.component';
import { RepocontactEditComponent } from './repocontact-edit/repocontact-edit.component';
import { RepocontactListComponent } from './repocontact-list/repocontact-list.component';
import { PositionListComponent } from './position-list/position-list.component';
import { PositionOrgPopupComponent } from './position-org-popup/position-org-popup.component';
import { RepoContactOrgPopupComponent } from './repo-contact-org-popup/repo-contact-org-popup.component';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SearchBoxModule } from '../shared/search-box/search-box.module';



@NgModule({
  declarations: [
    PositionsPopupComponent,
    RepoBusinessListComponent,
    RepoContactsPopupComponent,
    RepoBusinessPopupComponent,
    RepoBusinessComponent,
    PositionEditComponent,
    RepocontactEditComponent,
    RepocontactListComponent,
    PositionListComponent,
    PositionOrgPopupComponent,
    RepoContactOrgPopupComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbCollapseModule,
    AgGridModule,
    MatTableModule,
    MatTabsModule,
    MatCheckboxModule,
    NgbModule,
    NgbDropdownModule,
    InfiniteScrollModule,
    NgxIntlTelInputModule,
    MatSortModule,
    SearchBoxModule
  ],
  exports: [RepocontactEditComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class RepoBusinessModule {}
